import { DateTime } from "luxon";

/**
 * @typedef DateTimeRange
 * @prop {string} startDate start date/time in ISO format 
 * @prop {string} endDate end date/time in ISO format 
 */

/**
 * All params are pieces of data from the Scheduled Rule creator modal
 * @param {String} startDate
 * @param {String} startTime
 * @param {String} endDate
 * @param {String} endTime
 * @returns {DateTimeRange}
 */
export default (startDate, startTime, endDate, endTime) => {
  const timezone = { zone: "UTC" };
  const format = "yyyy-MM-dd hh:mm";
  const start = DateTime.fromFormat(`${startDate} ${startTime}`, format, timezone);
  const end = DateTime.fromFormat(`${endDate} ${endTime}`, format, timezone);

  return {
    startDate: start.toISO(),
    endDate: end.toISO(),
  };
};
